import { PersistentWorkItemState } from './persistent-work-item-state';

/**
 * The snapshot of workflow.
 */
export class PersistentWorkflowSnapshot {
    /**
     * The version number.
     */
    public version: number;

    /**
     * The instance ID.
     */
    public instanceId: number;

    /**
     * The work item ID.
     */
    public workItemId: number;

    /**
     * The work item state.
     */
    public workItemState: PersistentWorkItemState;

    /**
     * The persistent data for work item.
     */
    public workItemData: any;
}
